export default __webpack_public_path__ + "static/media/money.7fb82b8d.svg";